<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑流控规则' : '新增流控规则'"></el-page-header>
        <el-row>
            <el-col :span="18" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="业务" prop="code" :error="errors.code" v-if="$root.isAdmin">
                        <Cascade v-model="form.code"></Cascade>
                    </el-form-item>
                    <el-form-item label="单日预警限额" prop="alertThreshold" :error="errors.alertThreshold">
                        <el-input-number v-model="form.alertThreshold"></el-input-number>
                    </el-form-item>
                    <el-form-item label="预警信息发送" prop="alertTo" :error="errors.alertTo">
                        <el-input v-model="form.alertTo" type="textarea" :rows="3"></el-input>
                        <p class="help-text">单日发送总量超过预警限额时，发送预警信息。多个手机号以`,`分隔。</p>
                    </el-form-item>
                    <el-form-item label="单日禁止限额" prop="forbiddenThreshold" :error="errors.forbiddenThreshold">
                        <el-input-number v-model="form.forbiddenThreshold"></el-input-number>
                        <p class="help-text">单日发送总量超过禁止限额时，该业务账号禁止发送短信。</p>
                    </el-form-item>
                  <el-divider content-position="left">类型&国家防轰炸配置</el-divider>
                  <el-form-item :key="i" v-for="(item, i) in form.items">
                    <el-select v-model="item.type">
                      <el-option label="短信" value="SMS"></el-option>
                      <el-option label="视频短信" value="VIDEO"></el-option>
                      <el-option label="国际短信" value="ISMS"></el-option>
                      <el-option label="语音短信" value="VOICE"></el-option>
                    </el-select>
                    <el-input v-model="item.country" placeholder="国际区号" style="width: 100px"></el-input>
                    每&nbsp;<el-input-number v-model="item.duration"></el-input-number>
                    <el-select v-model="item.unit" style="width: 60px;">
                      <el-option label="秒" value="second"></el-option>
                      <el-option label="分" value="minute"></el-option>
                      <el-option label="时" value="hour"></el-option>
                      <el-option label="天" value="day"></el-option>
                    </el-select>
                    <el-input-number v-model="item.threshold"></el-input-number>&nbsp;条
                    <el-button type="text" icon="el-icon-delete" size="small" @click="removeItem(i)"></el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-plus" size="small" @click="addItem()">新增</el-button>
                  </el-form-item>

                    <el-divider content-position="left">防轰炸配置</el-divider>
                    <el-form-item label="规则一：" prop="thresholdBySecond">
                        每&nbsp;<el-input-number v-model="form.durationBySecond"></el-input-number>&nbsp;秒&nbsp;<el-input-number v-model="form.thresholdBySecond"></el-input-number>&nbsp;条
                    </el-form-item>
                    <el-form-item label="规则二：" prop="thresholdByMinute">
                        每&nbsp;<el-input-number v-model="form.durationByMinute"></el-input-number>&nbsp;分&nbsp;<el-input-number v-model="form.thresholdByMinute"></el-input-number>&nbsp;条
                    </el-form-item>
                    <el-form-item label="规则三：" prop="thresholdByHour">
                        每&nbsp;<el-input-number v-model="form.durationByHour"></el-input-number>&nbsp;时&nbsp;<el-input-number v-model="form.thresholdByHour"></el-input-number>&nbsp;条
                    </el-form-item>
                    <el-form-item label="规则四：" prop="thresholdByDay">
                        每&nbsp;<el-input-number v-model="form.durationByDay"></el-input-number>&nbsp;天&nbsp;<el-input-number v-model="form.thresholdByDay"></el-input-number>&nbsp;条
                        <p class="help-text">注：条数为 0 时，代表该项规则不做限制。</p>
                    </el-form-item>
                    <el-form-item label="白名单" prop="whiteList">
                        <el-input v-model="form.whiteList" type="textarea" :rows="3"></el-input>
                        <p class="help-text">白名单中的手机号不做限制。多个手机号以`,`分隔。</p>
                    </el-form-item>
                    <el-alert title="防轰炸功能" type="info" :closable="false" description="设置每个手机号在指定的间隔时间内，可以接收的短信数量。"></el-alert>
                    <br>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import Cascade from '@/components/Cascade'

export default {
    components: {
        Cascade,
    },
    data() {
        return {
            form: {
                id: this.$route.params.id,
                code: this.$root.isAdmin ? "" : this.$root.code,
                alertThreshold: 0,
                alertTo: "",
                forbiddenThreshold: 0,
                thresholdBySecond: 0,
                durationBySecond: 0,
                thresholdByMinute: 0,
                durationByMinute: 0,
                thresholdByHour: 0,
                durationByHour: 0,
                thresholdByDay: 0,
                durationByDay: 0,
                whiteList: "",
              items:[]
            },
            rules: {
                code: [
                    { required: true, message: "请选择业务" },
                ],
            },
            errors: {}
        }
    },
    beforeMount() {
        if (this.form.id > 0) {
            this.$axios.get("/raterule/get/" + this.form.id).then(result => {
                this.$utils.merge(this.form, result);
            })
        }
    },
    methods: {
      addItem() {
        this.form.items.push({
          threshold: 0,
          duration: 0,
          unit: "second",
          country: "",
          type: "SMS"
        });
      },
      removeItem(i) {
        this.form.items.splice(i);
      },
        submit() {
            if (this.form.code.length < 6) {
                this.$message.error("请选择具体业务！");
                return;
            }
            let url = this.form.id > 0 ? "/raterule/edit" : "/raterule/save";
            this.$utils.submit(this.$refs.form, url, this.form, () => {
                this.$router.go(-1);
            }, (data) => {
                this.errors = data;
            });
        },
        close() {
            this.$router.go(-1);
        }
    }
}
</script>